import curry from "./curry.js";

export default curry(function lte(a, b) {
  return a <= b;
});
